module.exports = __webpack_public_path__ + "static/media/townhall.51bdd6a9.png";